import PoxShippingVerification from './shippingVerification/PoxShippingVerification'
import { Routes, Route } from 'react-router-dom'
import Verify from './verifyContract/Verify'
import HstLayout from './hstPaperwork/HstLayout'

import routes from './../dme/constants/routes'
import PaymentSuccess from './PaymentSuccess'
import PaperworkComplete from './PaperworkComplete'
import PaperworkInsuranceReview from './PaperworkInsuranceReview'
import LandingLayout from './LandingLayout'
import StatementPaymentRouter from './StatementPaymentRouter'
import ReceiptPortal from './verifyContract/ReceiptPortal'
import StatementPaymentSuccess from './StatementPaymentSuccess'

const Landing = () => {
  return (
    <LandingLayout>
      <Routes>
        <Route path={`${routes.landing.verifyContract}`}>
          <Route path={`hst/:orderId/:nonce/*`} element={<HstLayout />} />
          <Route path={`aob/:orderId/:aobId`} element={<Verify />} />
          <Route path={`pox/:orderId/:nonce/*`} element={<PoxShippingVerification />} />
          <Route path={`statement`} element={<StatementPaymentRouter />} />
          <Route path={`receipt`} element={<ReceiptPortal />} />
        </Route>
        <Route path="statement/success" element={<StatementPaymentSuccess />} />
        <Route path="payment/:orderId/success" element={<PaymentSuccess />} />
        <Route path="paperwork/complete" element={<PaperworkComplete />} />
        <Route path="paperwork/insurance-review" element={<PaperworkInsuranceReview />} />
      </Routes>
    </LandingLayout>
  )
}

export default Landing
